module.exports = __webpack_public_path__ + "static/media/driver-promopage-bg-desktop.f8dcd113.png";